import { useMemo, useState } from 'react';

import {
  DEFAULT_PAGE_SIZE,
  filterMenus,
  ListFilter,
  paginate,
  totalPageCount,
} from '@/pages/externals/pos-menu-masters/service';
import { MosPosMenu } from '@/services/MosPosMenuMaster';

/**
 * SCR009 の検索・フィルター・ページネーションの状態です。
 * 一覧は1回の API 呼び出しで全件持っているため、絞り込みは全てここで行い
 * 追加のリクエストは出しません。
 */
export const useMenuMasterListView = (menus: MosPosMenu[]) => {
  const [keyword, setKeyword] = useState('');
  const [filter, setFilter] = useState<ListFilter>('all');
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);
  const [page, setPage] = useState(1);

  const filtered = useMemo(
    () => filterMenus(menus, keyword, filter),
    [menus, keyword, filter]
  );

  const totalPages = totalPageCount(filtered.length, pageSize);
  // 絞り込みで件数が減ったあとに範囲外のページへ取り残されないようにします。
  const currentPage = Math.min(page, totalPages);
  const pageMenus = paginate(filtered, currentPage, pageSize);

  /** 検索・フィルター・表示件数を変えたら必ず1ページ目へ戻します。 */
  const changeKeyword = (next: string) => {
    setKeyword(next);
    setPage(1);
  };

  const changeFilter = (next: ListFilter) => {
    setFilter(next);
    setPage(1);
  };

  const changePageSize = (next: number) => {
    setPageSize(next);
    setPage(1);
  };

  return {
    keyword,
    filter,
    pageSize,
    page: currentPage,
    totalPages,
    /** 絞り込み後の全件。CSVエクスポートはこの範囲を出します。 */
    filtered,
    /** 現在のページに表示する行。 */
    pageMenus,
    changeKeyword,
    changeFilter,
    changePageSize,
    setPage,
  };
};
